import React from 'react'
import { ClaimSearchCard } from '../cards/ClaimSearchCard'

export const ClaimSearchPage = (props) => {
  return <ClaimSearchCard className="h-100"></ClaimSearchCard>
}
